/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import Dish from '@/model/dish/Dish'
import Category from '@/model/dish/Category'
import CategoryType from '@/model/dish/CategoryType'

const entity = {

  code: {
    tableConfig: {
      width: '160',
    },
  },
  dishId: {
    displayName: 'name',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: Dish.getList,
        itemText: '_langsname',
      },
    },
  },
  showing: {
    type: IKDataEntity.Types.Boolean,
  },
  isFree: {
    type: IKDataEntity.Types.Boolean,
  },

  dishesCategoryId: {
    // displayName: 'consumeTypeId',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: Category.getList,
        itemText: '_langsname',
      },
    },
  },
  dishesCategoryTypeId: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: CategoryType.getList,
        itemText: 'name',
      },
    },
  },

}

let counter = 0
const config = {
  edit: function (item) {
    const request = []
    request.push(hillo.post('Dishes.php', item, {
      params: {
        op: (item.showing ? 'enable' : 'disable') + 'SingleDishShowInConsumeType',
      },
    }))
    request.push(hillo.post('Dishes.php', item, {
      params: {
        op: (item.isFree ? 'enable' : 'disable') + 'SingleDishFreeInConsumeType',
      },
    }))
    return Promise.all(request)
  },

  load: async function (filter) {
    return ((await hillo.get('Dishes.php?op=showDishesShowAndFreeByConsumeType',
      ...filter,
    ))
      .content).map(d => {
      d.id = counter
      counter++
      return d
    })
  },
}

export default IKDataEntity.ModelFactory(entity, config)
